import { type Enum } from '@webapp/infrastructure/types/Enum'

/**
 * The two tabs of the manage bank & credit card accounts page, and the route
 * params that drive them. They live beside the feature set rather than on the
 * page (modules/accounts-payable) so that this platform package does not
 * import a module; the page re-exports them for its route typing.
 */
export const ManageBankCreditCardAccountsTabs = {
  ACCOUNTS: 'bank-accounts',
  CREDIT_CARDS: 'credit-cards',
} as const

export type BankCreditCardAccountsTab = Enum<
  typeof ManageBankCreditCardAccountsTabs
>

export interface ManageBankCreditCardAccountsParams {
  status: BankCreditCardAccountsTab
}
